import React from 'react';
import { Alert, Snackbar } from '@mui/material'; 

const CustomAlert = ({
  open,
  message,
  severity = 'success', 
  onClose,
  autoHideDuration = 7000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled" 
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomAlert;
